module.exports = __webpack_public_path__ + "static/media/19.8089b44a.jpg";